import { useState, useEffect, useRef } from "react";

//componentes
import Header from "../../../../components/Header";
import Sidebar from "../../../../components/Sidebar";
import Legenda from "../../../../components/Legenda";
//Utils
import { dataAtual, dataAtualDia1, formatarData, formatarDataHoraBrasil } from "../../../../utils/datas";
import { statusSolicitacao } from "../../../../utils/choices";

//Mui
import { Input, Select, Stack, Typography, Option, Button, Table, Switch, Link, Modal, ModalDialog, ModalClose, Tooltip, Sheet } from "@mui/joy";

import { FaArrowUp, FaArrowDown, FaExternalLinkAlt, FaCopy, FaFilter, FaSearch } from "react-icons/fa";
import { IoMail, IoInformationCircleSharp } from "react-icons/io5";
//Material
import { Pagination } from '@mui/material/';
import useMediaQuery from '@mui/material/useMediaQuery';

import { toast } from 'react-toastify';
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

//API
import { api } from "../../../../services/api";
import { formatarMoeda } from "../../../../utils/moedas";
import Paginacao from "../../../../components/Paginacao";
import { formatarNCotacao } from "../../../../utils/mascaras";

const dadosUsuarioLogado = {};
let idUsuario = 0;
let token = "";

//Dados do usuário logado no localstorage
const usuarioLogado = JSON.parse(localStorage.getItem('usuario'));

export default function Compras(props) {

    const nSolicitacaoRef = useRef(null);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();

    // const [dataInicio, setDataInicio] = useState(dataAtual(-1));
    const [dataInicio, setDataInicio] = useState(dataAtualDia1());
    const [dataTermino, setDataTermino] = useState(dataAtual(1));
    const [status, setStatus] = useState(1);

    //Verificando se o dispositivo é mobile
    const mobile = useMediaQuery('(max-width:1200px)');

    const [cotacoes, setCotacoes] = useState([]);
    const [paginas, setPaginas] = useState({
        paginaAtual: 1,
        numeroPaginas: 1
    });
    const [ordenaDataEntrega, setOrdenaDataEntrega] = useState(null);
    const [modalExibirItens, setModalExibirItens] = useState(false);
    const [modalFiltros, setModalFiltros] = useState(false);

    const [itensDaRequisicao, setItensDaRequisicao] = useState([]);
    const [totalCotacao, setTotalCotacao] = useState(0.00);
    const [filtros, setFiltros] = useState({ cotacaoBusca: "", etapaAtualBuscada: "", dataInicio: "", dataTermino: "", status: "", verTodasCotacoes: searchParams.get('verTodasCotacoes') === 'true', verPedidosQueAtuei: "", pagina: 1, numero1108: "", solicitacao: "", item: "", numero1106: "", fornecedor: "", equipamento: "", prefixoEquipamento: "" });
    const [modalEmailsEnviados, setModalEmailsEnviados] = useState(false);
    const [emailSelecionado, setEmailSelecionado] = useState(null);
    const [emailsEnviados, setEmailsEnviados] = useState([]);
    const [modalMensagem, setModalMensagem] = useState(false);
    const [dadosModalMensagem, setDadosModalMensagem] = useState({});
    const [primeiraBusca, setPrimeiraBusca] = useState(false);
    const [loading, setLoading] = useState(true);

    const [etapaAtualBuscada, setEtapaAtualBuscada] = useState(null);

    useEffect(() => {
        if (JSON.parse(localStorage.getItem("usuario")) != null) {
            dadosUsuarioLogado.nome = usuarioLogado.user.nome;
            dadosUsuarioLogado.usuario = usuarioLogado.user.login;
            dadosUsuarioLogado.obra = usuarioLogado.user.obra;
            dadosUsuarioLogado.grupo = usuarioLogado.grupo;
            dadosUsuarioLogado.id = usuarioLogado.user?.id;

            token = JSON.parse(localStorage.getItem('usuario')).token;
            idUsuario = JSON.parse(localStorage.getItem('usuario')).user.id;

            let permissoes = [];
            if (dadosUsuarioLogado.grupo.length > 0) {
                dadosUsuarioLogado.grupo.forEach((item) => {
                    permissoes.push(item.perfil);
                })
            }
            dadosUsuarioLogado.permissoes = permissoes;
        }
        // buscarCotacoes();
    }, []);

    //Recarrega a lista toda vez que clica na coluna data:
    useEffect(() => {
        if (ordenaDataEntrega != null) {
            buscarCotacoes(paginas.paginaAtual);
        }
    }, [ordenaDataEntrega]);

    useEffect(() => {
        const cotacaoBusca = searchParams.get('cotacaoBusca') || "";
        const etapaAtualBuscada = searchParams.get('etapaAtualBuscada') || "";
        const dataInicio = searchParams.get('dataInicio') || dataAtualDia1();
        const dataTermino = searchParams.get('dataTermino') || dataAtual();
        const status = searchParams.get('status') || 1;
        const verTodasCotacoes = searchParams.get('verTodasCotacoes') || undefined;
        const verPedidosQueAtuei = searchParams.get('verPedidosQueAtuei') || "";
        const numero1108 = Number(searchParams.get('numero1108')) || "";
        const numero1106 = Number(searchParams.get('numero1106')) || "";
        const pagina = numero1108 ? 1 : Number(searchParams.get('pagina')) || 1;
        const solicitacao = searchParams.get('solicitacao') || "";
        const item = searchParams.get('item') || "";
        const fornecedor = searchParams.get('fornecedor') || "";
        const equipamento = searchParams.get('equipamento') || "";
        const prefixoEquipamento = searchParams.get('prefixoEquipamento') || "";

        paginas.paginaAtual = pagina;

        const filtros = { cotacaoBusca, etapaAtualBuscada, dataInicio, dataTermino, status, verTodasCotacoes, verPedidosQueAtuei, pagina, numero1108, solicitacao, item, numero1106, fornecedor, equipamento, prefixoEquipamento };
        setFiltros({ cotacaoBusca, etapaAtualBuscada, dataInicio, dataTermino, status, verTodasCotacoes, verPedidosQueAtuei, pagina, numero1108, solicitacao, item, numero1106, fornecedor, equipamento, prefixoEquipamento });

        if (filtros.dataInicio && filtros.dataTermino) {
            setTimeout(() => {
                buscarCotacoes(pagina, filtros);
            }, 1000);
        }
    }, []);

    useEffect(() => {
        if (modalFiltros) {
            setTimeout(() => {
                if (modalFiltros && nSolicitacaoRef.current) {
                    nSolicitacaoRef.current.focus();
                }
            }, 100);
        }
    }, [modalFiltros]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter") {
                buscarCotacoes();
                setModalFiltros(false);
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [filtros]);

    const handleOrdenaDataEntrega = () => {
        // define estado da variavel ordenaDataAbertura (estados null, true ou false)
        if (ordenaDataEntrega == null) {
            setOrdenaDataEntrega(true);
        } else if (ordenaDataEntrega == true) {
            setOrdenaDataEntrega(false);
        }
        else if (ordenaDataEntrega == false) {
            setOrdenaDataEntrega(null);
        }
    }

    const buscarCotacoes = (pagina = 1, filters = filtros) => {

        setLoading(true);

        if (!filters.dataInicio) {
            // filters.dataInicio = dataAtual(-1);
            filters.dataInicio = dataAtualDia1();
        }

        if (!filters.dataTermino) {
            filters.dataTermino = dataAtual(1);
        }

        if (!filters.status) {
            filters.status = 1;
        }

        let urlBuscarCotacoes = `/cotacoes?paginacao=true&page=${pagina}&datasolicitacaoi=${filters.dataInicio}&datasolicitacaof=${filters.dataTermino}&status=${filters.status}&todos=${filters.verTodasCotacoes}&usuario=${idUsuario}&codcotacao=${filters.cotacaoBusca}&etapaatual=${filters.etapaAtualBuscada}&numero1108=${filters.numero1108}&solicitacao=${filters.solicitacao}&item=${filters.item}&numero1106=${filters.numero1106 || ""}&fornecedor=${filters.fornecedor}&equipamento=${filters.equipamento}&prefixo_equipamento=${filters.prefixoEquipamento}&pedidos_que_atuei=${filters.verPedidosQueAtuei}`;
        //Ordenar data criacao:
        if (ordenaDataEntrega != null) {
            urlBuscarCotacoes += `&orderDataEntrega=${ordenaDataEntrega}`;
        }

        api.get(urlBuscarCotacoes,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        ).then((response) => {
            let cotacoesDoBanco = [];
            if (response.data) {
                const dados = response.data;
                console.log("Mac ", dados);
                dados.data.forEach(cotacao => {
                    cotacoesDoBanco.push(
                        {
                            id: cotacao.id,
                            serie: cotacao.serie,
                            solicitacaoID: cotacao.solicitacao_id,
                            etapaAtual: cotacao.etapaAtual,
                            status: cotacao.status,
                            dataAbertura: formatarData(cotacao.dataAbertura.split(" ")[0]),
                            dataEntrega: formatarData(cotacao.dataEntrega.split(" ")[0]),
                            codCotacao: cotacao.codCotacao,
                            comprador: cotacao.comprador,
                            aprovAtual: cotacao?.etapaPresente?.usuario || "",
                            fornecedor: cotacao.fornecedor,
                            condPagamento: cotacao.condPagamento,
                            tipoFrete: cotacao.tipoFrete,
                            tipoPedido: cotacao.tipoPedido,
                            numeroMov6: cotacao.numeroMov6,
                            numeroMov8: cotacao.numeroMov8,
                            numeroOC: cotacao.numeroOC,
                            numeroMov22: cotacao.numeroMov22,
                            decisao: cotacao.decisao,
                            codloc: cotacao.codloc,
                            prazo_entrega: cotacao.prazo_entrega,
                            compradorFechamentoID: cotacao.compradorFechamentoID,
                            prioridade: cotacao.criterio,
                            jaReprovado: cotacao.fluxo_aprovacoes.some(item => item.decisao === 'Reprovado'),
                            regularizacao: cotacao.regularizacao,
                            multiplosAprovadores: cotacao.multiplosAprovadores,
                            emails: cotacao.emails
                        }
                    );
                });

                console.log({ cotacoesDoBanco });

                setCotacoes(cotacoesDoBanco);

                //Definindo a paginação
                paginas.numeroPaginas = dados.meta.last_page;
                // paginas.paginaAtual = pagina;

                // setModalFiltros(false);
            }

            if (primeiraBusca) {
                setModalFiltros(false);
            }
            else {
                setPrimeiraBusca(true);
            }

        }).catch((error) => {
            console.log(error);
            if (error?.response?.data?.message == "Unauthenticated.") {
                localStorage.setItem("usuario", null);
                // navigate("/acessoNegado");
                navigate("/");
            }
            else {
                toast.error("Ocorreu um erro ao obter as cotações.");
                console.log(error?.response?.data?.message);
            }
            toast.error(JSON.stringify(error?.response?.data));
        }).finally(() => {
            setLoading(false);
        });
    }

    const alterarPagina = (event, value) => {
        paginas.paginaAtual = value;
        buscarCotacoes(value);
        aplicarFiltros('pagina', value);
    }

    const exibirItens = (e, solicitacao) => {
        e.stopPropagation();

        //Obtendo os itens da requisição
        api.get(`/cotacoes/${solicitacao}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        )
            .then(function ({ data }) {
                console.log("Itens da requisição ", data);
                setItensDaRequisicao(data.data.itens.map(itens => ({ ...itens, tipoPedido: data.data.tipoPedido })));
                setTotalCotacao(data.data.totalCotacao);
                setModalExibirItens(true);

            })
            .catch(function (err) {
                console.log(err);
                toast.error(JSON.stringify(err.response.data));
            });
    }

    // const aplicarFiltros = (key, value) => {
    //     setFiltros(current => ({
    //         ...current,
    //         [key]: value
    //     }));
    //     if (value) {
    //         searchParams.set(key, value);
    //         setSearchParams(searchParams);
    //         return;
    //     }
    //     searchParams.delete(key);
    //     setSearchParams(searchParams);
    // }

    const aplicarFiltros = (key, value) => {
        setFiltros(current => ({ ...current, [key]: value }));

        console.log({ key });
        console.log({ value });
        setSearchParams(prev => {
            const next = new URLSearchParams(prev);
            if (value) {
                next.set(key, value);
            }
            else {
                next.delete(key);
            }
            return next;
        });
    };

    const abrirCotacao = (route) => {
        navigate(route + location.search);
    }

    const abrirNovaAba = (event, cotacao) => {
        event.stopPropagation();
        window.open('/aprovacaoCompras/' + cotacao)
    }

    const copiarNumMovimento = async (event, numeroMovimento) => {
        event.stopPropagation();
        try {
            await navigator.clipboard.writeText(numeroMovimento);
            toast.info("Movimento copiado");
        } catch (err) {
            console.error("Erro ao copiar:", err);
            toast.warning("Erro ao copiar o movimento");
            toast.error(JSON.stringify(err));
        }
    }

    const resetFilters = () => {
        const filtros = {
            dataInicio: dataAtualDia1(),
            dataTermino: dataAtual(),
            cotacaoBusca: "",
            etapaAtualBuscada: "",
            status: 1,
            verTodasCotacoes: "",
            verPedidosQueAtuei: "",
            pagina: 1,
            numero1108: "",
            solicitacao: "",
            item: "",
            fornecedor: "",
            equipamento: "",
            prefixoEquipamento: ""
        };
        setFiltros(filtros);
        buscarCotacoes(1, filtros);
    }

    return (
        <Stack backgroundColor="#fff" height="100%" minHeight={"100vh"}>
            <Header notification mobile={mobile} />
            <Sidebar mobile={mobile} />

            <Stack ml={mobile ? "0px" : "280px"} mt={"50px"} flex={1} height={mobile ? "100%" : "calc(100% - 55px)"} p={mobile ? "20px" : "50px"} overflowY="auto">
                {/* Conteúdo da Tela */}
                <Stack flexDirection={'row'} justifyContent={'space-between'}>
                    <Typography level="h4">Movimentos de Compras</Typography>
                    <Legenda mobile={mobile} />
                </Stack>
                <Stack ml={mobile ? "0px" : "0px"}>
                    <Stack flexDirection={mobile ? "column" : "row"} mt={mobile ? "20px" : "30px"} alignItems={mobile ? "flex-start" : "center"} justifyContent={"space-between"}>
                        <Stack width={mobile ? "100%" : "unset"} flexDirection={mobile ? "column" : "row"} flexWrap={'wrap'}>
                            <Stack mb={mobile ? "10px" : "0px"} mr={mobile ? "0px" : "10px"}>
                                <Typography level="body-sm">N° da Cotação</Typography>
                                <Stack>
                                    <Input value={filtros.cotacaoBusca} onChange={e => aplicarFiltros("cotacaoBusca", formatarNCotacao(e.target.value))} placeholder="0000.000000" sx={mobile ? {} : { width: "132px" }} />
                                </Stack>
                            </Stack>
                            <Stack>
                                <Typography level="body-sm">Criadas a partir de:</Typography>
                                <Input type="date" value={filtros.dataInicio} onChange={(event) => aplicarFiltros("dataInicio", event.target.value)} />
                            </Stack>
                            <Stack ml={mobile ? "0px" : "10px"} mt={mobile ? "10px" : "0px"} mb={mobile ? "10px" : "0px"}>
                                <Typography level="body-sm">Até esta data:</Typography>
                                <Input type="date" value={filtros.dataTermino} onChange={(event) => aplicarFiltros("dataTermino", event.target.value)} />
                            </Stack>
                            <Stack ml={mobile ? "0px" : "10px"} width={"130px"} mt={mobile ? "10px" : "0px"} mb={mobile ? "10px" : "0px"}>
                                <Typography level="body-sm">N° Solicitação</Typography>
                                <Stack>
                                    {/* <input ref={nSolicitacaoRef} value={filtros.solicitacao} onChange={e => aplicarFiltros("solicitacao", e.target.value)} placeholder="0000" style={{ fontSize: "16px", fontWeight: 500, color: "#333", border: '1px solid #ddd', borderRadius: "5px", padding: "10px 10px", backgroundColor: "#fcfcfc" }} /> */}
                                    <input
                                        ref={nSolicitacaoRef}
                                        type="text"
                                        value={filtros.solicitacao ?? ''}
                                        onChange={(event) => {
                                            const valor = event.target.value;
                                            aplicarFiltros('solicitacao', valor);
                                            if (valor.length > 0) aplicarFiltros('verTodasCotacoes', true);
                                        }}
                                        placeholder="0000"
                                        style={{ fontSize: "16px", fontWeight: 500, color: "#333", border: '1px solid #ddd', borderRadius: "5px", padding: "10px 10px", backgroundColor: "#fcfcfc" }}
                                    />
                                </Stack>
                            </Stack>
                            {/* <Stack ml={mobile ? "0px" : "20px"} mt={mobile ? "10px" : "0px"} mb={mobile ? "20px" : "0px"}>
                                <Typography level="body-sm">Status</Typography>
                                <Select fontSize={12} value={filtros.status} onChange={(event, newValue) => aplicarFiltros("status", newValue)} placeholder="Status da Solicitação">
                                    <Option value={1}>Em Andamento</Option>
                                    <Option value={2}>Cancelado</Option>
                                    <Option value={3}>Concluído</Option>
                                </Select>
                            </Stack>
                            <Stack mb={mobile ? "40px" : "0px"} ml={mobile ? "0px" : "20px"}>
                                <Typography level="body-sm">N° 1.1.08</Typography>
                                <Stack>
                                    <Input value={filtros.numero1108} onChange={e => aplicarFiltros("numero1108", e.target.value)} placeholder="0000000" sx={{ width: "130px" }} />
                                </Stack>
                            </Stack>
                            <Stack mb={mobile ? "40px" : "0px"} ml={mobile ? "0px" : "20px"} mr={"30px"}>
                                <Typography level="body-sm">Solicitação</Typography>
                                <Stack>
                                    <Input value={filtros.solicitacao} onChange={e => aplicarFiltros("solicitacao", e.target.value)} placeholder="0000" sx={{ width: "130px" }} />
                                </Stack>
                            </Stack> */}
                            <Stack ml={mobile ? "0px" : "20px"} mr={mobile ? "0px" : "20px"} mb={mobile ? "30px" : "0px"}>
                                <Typography level="body-sm">Ver todos</Typography>
                                <Stack alignSelf={"flex-start"} justifyContent="center" maxHeight={'35px'} flex={mobile ? null : 1}>
                                    {/* <Switch
                                        checked={filtros.verTodasCotacoes}
                                        onChange={(event) => [aplicarFiltros("verTodasCotacoes", event.target.checked), !event.target.checked ? aplicarFiltros("verPedidosQueAtuei", "") : null]}
                                    /> */}
                                    <Switch
                                        checked={Boolean(filtros.verTodasCotacoes)}
                                        onChange={(event) => {
                                            const checked = event.target.checked;
                                            aplicarFiltros('verTodasCotacoes', checked);
                                            if (!checked) aplicarFiltros('verPedidosQueAtuei', '');
                                        }}
                                    />
                                </Stack>
                            </Stack>
                            <Stack mr={mobile ? "0px" : "20px"} mb={mobile ? "30px" : "0px"}>
                                <Typography level="body-sm">Ver pedidos que atuei</Typography>
                                <Stack alignSelf={"flex-start"} maxHeight={'35px'} justifyContent="center" flex={mobile ? null : 1}>
                                    <Switch
                                        checked={filtros.verPedidosQueAtuei}
                                        onChange={(event) => [aplicarFiltros("verPedidosQueAtuei", event.target.checked), event.target.checked ? aplicarFiltros("verTodasCotacoes", event.target.checked) : null]}
                                    />
                                </Stack>
                            </Stack>
                            <Stack ml={mobile ? "" : "0px"} mb={mobile ? "20px" : "0px"} mt={'10px'} display={"flex"}>
                                <Button color="neutral" variant="solid" onClick={() => setModalFiltros(true)}><FaFilter style={{ marginRight: "5px" }} /> FILTROS</Button>
                                <Link onClick={resetFilters} variant="plain" color="danger" level="body-sm">Limpar Filtros</Link>
                            </Stack>

                            <Stack ml={mobile ? "" : "30px"} mb={mobile ? "10px" : "0px"} display={"flex"} justifyContent={"flex-end"}>
                            </Stack>
                        </Stack>
                    </Stack>
                    <Stack flexDirection={"row"} mt={'3px'} justifyContent={mobile ? "space-between" : "flex-start"} width={mobile ? "100%" : "auto"}>
                        <Button loading={loading} sx={mobile ? { width: "100%" } : {}} onClick={() => buscarCotacoes()}><FaSearch style={{ marginRight: "5px" }} /> ATUALIZAR</Button>
                    </Stack>
                </Stack>
                <Stack mt="30px">

                    <Stack mt={3} alignItems={mobile ? "center" : "flex-end"}>
                        <Paginacao paginaAtual={paginas.paginaAtual} alterarPagina={alterarPagina} totalPaginas={paginas.numeroPaginas} />
                    </Stack>

                    {mobile ?
                        <Stack>
                            {cotacoes.map(function (item, indice) {
                                let podeAprovar = false;
                                let corDaLinha = "";

                                if (dadosUsuarioLogado.permissoes) {

                                    const obraEPermissao = dadosUsuarioLogado.grupo.filter(grupo => grupo.perfil == item.etapaAtual
                                        && grupo.obra == item.codloc
                                        && grupo.tipoPedido.includes(item.tipoPedido)
                                    ).length > 0;

                                    if (
                                        ((dadosUsuarioLogado.permissoes.indexOf(item.etapaAtual) != -1) && obraEPermissao)
                                    ) {
                                        if (item.etapaAtual == "Comprador" && (item.compradorFechamentoID == dadosUsuarioLogado.id)) {
                                            podeAprovar = true;
                                            corDaLinha = "#ffe082";
                                        }
                                        else if (item.multiplosAprovadores > 1 && item.etapaAtual != "Comprador") {
                                            podeAprovar = true;
                                            corDaLinha = "#57cc99";
                                        }
                                        else if (item.etapaAtual != "Comprador") {
                                            podeAprovar = true;
                                            corDaLinha = "#ffe082";
                                        }
                                    }
                                    if (item.decisao == "Reprovado" && obraEPermissao) {
                                        corDaLinha = "#ef9a9a";
                                    }
                                }

                                return (
                                    <div className="hover">
                                        <Stack key={indice} onClick={() => abrirCotacao("/aprovacaoCompras/" + item.numeroMov6)} p={"10px"} boxShadow="md" borderRadius={5} mb={"20px"} sx={{ userSelect: "none" }} style={{ backgroundColor: corDaLinha }}>
                                            {/* <Stack key={indice} onClick={() => navigate("/aprovacaoCompras/" + item.numeroMov6, { state: { cotacao: item } })} p={"10px"} boxShadow="md" borderRadius={5} mb={"20px"} sx={{ userSelect: "none" }} style={{ backgroundColor: corDaLinha }}> */}
                                            <Typography level="body-lg" borderBottom={1} borderColor="#ccc" mb={"10px"}><Typography level="title-lg">Cotação: </Typography>{item.codCotacao}</Typography>
                                            <Typography level="body-sm"><Typography level="title-md">Solicitação: </Typography>{item.solicitacaoID}</Typography>
                                            <Typography level="body-sm"><Typography level="title-md">Etapa Atual: </Typography>{item.etapaAtual}</Typography>
                                            <Typography level="body-sm"><Typography level="title-md">Data Entrega: </Typography>{item.dataEntrega}</Typography>
                                            <Typography level="body-sm"><Typography level="title-md">Prazo entrega: </Typography>{item.prazo_entrega}</Typography>
                                            <Typography level="body-sm"><Typography level="title-md">Comprador: </Typography>{item.comprador}</Typography>
                                            <Typography level="body-sm"><Typography level="title-md">Etapa atual: </Typography>{item.etapaAtual}</Typography>
                                            <Typography level="body-sm"><Typography level="title-md">Fornecedor: </Typography>{item.fornecedor}</Typography>
                                            <Typography level="body-sm"><Typography level="title-md">Nº 1.1.06: </Typography>{item.numeroMov6}</Typography>
                                            <Typography level="body-sm"><Typography level="title-md">Status: </Typography>{statusSolicitacao(item.status)}</Typography>
                                            <h4 onClick={(e) => exibirItens(e, item.numeroMov6)} style={{ padding: 0, margin: 0, marginTop: "10px", color: "#1565c0" }}>Ver Itens</h4>
                                        </Stack>
                                    </div>
                                )
                            })}
                        </Stack>
                        :
                        <Stack>
                            <Table hoverRow noWrap>
                                <thead>
                                    <tr>
                                        <th style={{ height: "25px", width: "95px" }}>Cotação</th>
                                        <th style={{ height: "25px", width: "150px" }}></th>
                                        <th style={{ height: "25px", width: "75px" }}>Solicitação</th>
                                        <th style={{ height: "25px", width: "70px" }}>Prioridade</th>
                                        {/* <th style={{ height: "25px", width: "95px" }}>Regularização</th> */}
                                        <th style={{ height: "25px", width: "65px" }}>Revisado</th>
                                        <th style={{ height: "25px", width: "65px" }}>N° 1.1.06</th>
                                        <th style={{ height: "25px", width: "80px" }}>N° OC</th>
                                        <th style={{ height: "25px", width: "55px" }}>Estoque</th>
                                        <th style={{ height: "25px", width: "90px" }}>Data Requisição</th>
                                        <th style={{ height: "25px", width: "90px" }}><Link onClick={() => handleOrdenaDataEntrega()}>Data Entrega {ordenaDataEntrega != null ? ordenaDataEntrega ? <FaArrowDown size={10} style={{ marginLeft: "2px" }} /> : <FaArrowUp size={10} style={{ marginLeft: "2px" }} /> : ""} </Link></th>
                                        <th style={{ height: "25px", width: "150px" }}>Etapa Atual</th>
                                        <th style={{ height: "25px", width: "80px" }}>Aprov. atual</th>
                                        <th style={{ height: "25px", width: "200px" }}>Fornecedor</th>
                                        <th style={{ height: "25px", width: "100px" }}>Comprador</th>
                                        <th style={{ height: "25px", width: "50px" }}>Prazo</th>
                                        <th style={{ height: "25px", width: "120px" }}>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cotacoes.map(function (item, indice) {
                                        let podeAprovar = false;
                                        let corDaLinha = "";

                                        if (dadosUsuarioLogado.permissoes) {

                                            const obraEPermissao = dadosUsuarioLogado.grupo.filter(grupo => grupo.perfil == item.etapaAtual
                                                && grupo.obra == item.codloc
                                                && grupo.tipoPedido.includes(item.tipoPedido)
                                            ).length > 0;

                                            if (
                                                ((dadosUsuarioLogado.permissoes.indexOf(item.etapaAtual) != -1) && obraEPermissao)
                                            ) {
                                                if (item.etapaAtual == "Comprador" && (item.compradorFechamentoID == dadosUsuarioLogado.id)) {
                                                    podeAprovar = true;
                                                    corDaLinha = "#ffe082";
                                                }
                                                else if (item.multiplosAprovadores > 1 && item.etapaAtual != "Comprador") {
                                                    podeAprovar = true;
                                                    corDaLinha = "#57cc99";
                                                }
                                                else if (item.etapaAtual != "Comprador") {
                                                    podeAprovar = true;
                                                    corDaLinha = "#ffe082";
                                                }
                                            }
                                            if (item.decisao == "Reprovado" && obraEPermissao) {
                                                corDaLinha = "#ef9a9a";
                                            }
                                        }

                                        return (
                                            <tr key={indice} className="hover" onClick={() => abrirCotacao("/aprovacaoCompras/" + item.numeroMov6)} style={{ backgroundColor: corDaLinha }} >
                                                {/* <tr key={indice} className="hover" onClick={() => navigate("/aprovacaoCompras/" + item.numeroMov6, { state: { cotacao: item } })} style={{ backgroundColor: corDaLinha }} > */}
                                                <td style={{ padding: "0 10px" }}>{item.codCotacao}</td>
                                                <td style={{ padding: "0 10px", fontWeight: "bold", display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "20px", minWidth: "180px" }}>
                                                    <h4 onClick={(e) => exibirItens(e, item.numeroMov6)} style={{ padding: 0, margin: 0, color: "#1565c0", whiteSpace: "nowrap" }}>Ver Itens</h4>
                                                    <FaExternalLinkAlt size={15} onClick={(e) => abrirNovaAba(e, item.numeroMov6)} style={{ cursor: "pointer", flexShrink: 0 }} />
                                                    <div style={{ width: "18px", height: "18px", flexShrink: 0 }}>
                                                        {item.emails && item.emails.length > 0 && (
                                                            <IoMail
                                                                size={18}
                                                                style={{ cursor: "pointer", color: "#1976d2", flexShrink: 0 }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setEmailsEnviados(item.emails);
                                                                    setModalEmailsEnviados(true);
                                                                }}
                                                                title="Visualizar emails enviados"
                                                            />
                                                        )}
                                                    </div>
                                                </td>
                                                <td style={{ padding: "0 10px" }}>{item.solicitacaoID}</td>
                                                <td style={(item.prioridade == "UR") ? { padding: "0 10px", color: "#f44336", textAlign: "center", fontWeight: "bold" } : { padding: "0 10px", textAlign: "center" }}>{item.prioridade}</td>
                                                {/* <td style={{ padding: "0 10px", textAlign: 'center' }}>{item.regularizacao == 0 ? 'Não' : "Sim"}</td> */}
                                                <Tooltip arrow title={item.jaReprovado ? "Processo reprovado anteriormente, favor verificar se todos os questionamentos foram atendidos." : ""} color="warning" placement="bottom" variant={"solid"}>
                                                    <td style={item.jaReprovado ? { padding: "0 10px", color: "#f57c00", fontWeight: "bold" } : { padding: "0 10px" }}>{item.jaReprovado ? "Sim" : "Não"}</td>
                                                </Tooltip>
                                                <td style={{ padding: "0 10px" }}>{item.numeroMov6}</td>
                                                <td style={{ padding: "0 10px" }}>{item.numeroOC && <FaCopy onClick={(e) => copiarNumMovimento(e, item.numeroOC)} style={{ marginRight: "8px", cursor: "pointer", color: "#1976d2" }} />}<label style={{ cursor: "pointer" }}>{item.numeroOC}</label></td>
                                                <td style={{ padding: "0 10px" }}>{item.codloc}</td>
                                                <td style={{ padding: "0 10px" }}>{item.dataAbertura}</td>
                                                <td style={{ padding: "0 10px" }}>{item.dataEntrega}</td>
                                                <Tooltip arrow title={item.etapaAtual} color="primary" placement="bottom" variant={"solid"}>
                                                    <td style={{ padding: "0 10px" }}>{item.etapaAtual}</td>
                                                </Tooltip>
                                                <Tooltip arrow title={item.aprovAtual} color="primary" placement="bottom" variant={"solid"}>
                                                    <td style={{ padding: "0 10px" }}>{item.aprovAtual}</td>
                                                </Tooltip>
                                                <Tooltip arrow title={item.fornecedor} color="primary" placement="bottom" variant={"solid"}>
                                                    <td style={{ padding: "0 10px" }}>{item.fornecedor}</td>
                                                </Tooltip>
                                                <Tooltip arrow title={item.comprador} color="primary" placement="bottom" variant={"solid"}>
                                                    <td style={{ padding: "0 10px" }}>{item.comprador}</td>
                                                </Tooltip>
                                                <td style={{ padding: "0 10px" }}>{item.prazo_entrega}</td>
                                                <td style={{ padding: "0 10px", fontWeight: "bold" }}>{statusSolicitacao(item.status)}</td>
                                                {/* <td style={{ padding: "0 10px", fontWeight: "bold" }}><h4 onClick={(e) => exibirItens(e, item.numeroMov6)} style={{ padding: 0, margin: 0, color: "#1565c0" }}>Ver Itens</h4></td> */}
                                                {/* <td style={{ padding: "0 10px", fontWeight: "bold", display: "flex", flexDirection: "row", alignItems: "center", gap: "20px" }}>
                                                    <h4 onClick={(e) => exibirItens(e, item.numeroMov6)} style={{ padding: 0, margin: 0, color: "#1565c0" }}>Ver Itens</h4>
                                                    <FaExternalLinkAlt onClick={(e) => abrirNovaAba(e, item.numeroMov6)} />
                                                </td> */}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </Stack>
                    }
                    <Stack mt={3} alignItems={mobile ? "center" : "flex-end"}>
                        {/* <Pagination
                            onChange={alterarPagina}
                            count={paginas.numeroPaginas}
                            page={paginas.paginaAtual}
                            hideNextButton={paginas.paginaAtual == paginas.numeroPaginas}
                            hidePrevButton={paginas.paginaAtual == 1}
                        /> */}
                        <Paginacao paginaAtual={paginas.paginaAtual} alterarPagina={alterarPagina} totalPaginas={paginas.numeroPaginas} />
                    </Stack>
                </Stack>
            </Stack>

            <Modal open={modalExibirItens} onClose={() => setModalExibirItens(false)}>
                <ModalDialog>
                    <ModalClose />
                    <Typography sx={{ fontWeight: "bold", marginBottom: "3px" }}>Itens da Requisição</Typography>
                    <Typography sx={{ color: "#444", fontSize: 14 }}>Tipo de Pedido: <Typography sx={{ backgroundColor: "#eee", padding: '2px 5px', borderRadius: '5px' }}>{itensDaRequisicao[0]?.tipoPedido}</Typography></Typography>
                    <Stack overflow={"auto"} sx={{ marginTop: '5px' }}>
                        <Table hoverRow noWrap>
                            <thead>
                                <tr>
                                    <th style={{ height: "25px", width: "30px" }}>Item</th>
                                    <th style={{ height: "25px", width: "50px" }}>Código</th>
                                    <th style={{ height: "25px", minWidth: "100px", flexGrow: 1 }}>Descrição</th>
                                    <th style={{ height: "25px", width: "50px" }}>Saldo</th>
                                    <th style={{ height: "25px", width: "50px" }}>Qtd.</th>
                                    <th style={{ height: "25px", width: "110px" }}>Preco unit.</th>
                                    <th style={{ height: "25px", width: "110px" }}>Preco total.</th>
                                    {/* <th style={{ height: "25px", width: "300px" }}>Tipo Pedido</th> */}
                                    {/* <th style={{ height: "25px", width: "100px" }}>Qtd. Comprar</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {itensDaRequisicao.map(function (item, indice) {
                                    return (
                                        <tr key={indice}>
                                            <td style={{ padding: "0 10px" }}>{indice + 1}</td>
                                            <td style={{ padding: "0 10px" }}>{item.codProduto}</td>
                                            <td style={{ padding: "0 10px" }}>{item.descricao}</td>
                                            <td style={{ padding: "0 10px" }}>{item.estoque}</td>
                                            <td style={{ padding: "0 10px" }}>{item.quantidadeProduto}</td>
                                            <td style={{ padding: "0 10px" }}>{formatarMoeda(item.precoUnit)}</td>
                                            <td style={{ padding: "0 10px" }}>{formatarMoeda(item.precoTotal)}</td>
                                            {/* <td style={{ padding: "0 10px" }}>{item.tipoPedido}</td> */}
                                            {/* <td style={{ padding: "0 10px" }}>{item.quantidadeComprarRM}</td> */}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </Stack>
                    <Typography sx={{ alignSelf: "end", marginTop: "20px" }}>Total da requisição: <label style={{ fontWeight: "bold" }}>{formatarMoeda(totalCotacao)}</label></Typography>
                </ModalDialog>
            </Modal>

            <Modal open={modalFiltros} onClose={() => setModalFiltros(false)}>
                <ModalDialog>
                    <ModalClose />
                    <Typography fontSize={"18px"} mb={"16px"} fontWeight={"bold"}>Filtros</Typography>
                    {/* <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            buscarCotacoes();
                            setModalFiltros(false)
                        }}
                    > */}
                    <button type="submit" style={{ display: 'none' }} />
                    <Stack sx={mobile ? { width: "100%", maxHeight: "70vh" } : { width: "400px", maxHeight: "70vh" }} gap={"14px"} overflow={"auto"}>
                        <Stack>
                            <Typography level="body-sm" fontWeight={"bold"}>Status</Typography>
                            <Select fontSize={12} value={filtros.status} onChange={(event, newValue) => aplicarFiltros("status", newValue)} placeholder="Status da Solicitação">
                                <Option value={1}>Em Andamento</Option>
                                <Option value={2}>Cancelado</Option>
                                <Option value={3}>Concluído</Option>
                            </Select>
                        </Stack>
                        <Stack mb={mobile ? "20px" : "0px"}>
                            <Typography level="body-sm" fontWeight={"bold"}>Etapa Atual</Typography>
                            <Select fontSize={12} value={filtros.etapaAtualBuscada} onChange={(event, newValue) => aplicarFiltros('etapaAtualBuscada', newValue)} placeholder="Selecionar">
                                <Option value={""} selected>Todas</Option>
                                <Option value={"Comprador"}>Comprador</Option>
                                <Option value={"Aprov. mcp1"}>Aprov. mcp1</Option>
                                <Option value={"Aprov. mcp2"}>Aprov. mcp2</Option>
                                <Option value={"Aprov. mcpf"}>Aprov. mcpf</Option>
                                <Option value={"Aprov. gestor adm suprimentos"}>Aprov. gestor adm suprimentos</Option>
                                <Option value={"Aprov. gestor contrato/equipamentos"}>Aprov. gestor contrato/equipamentos</Option>
                                <Option value={"Aprov. gestor corporativo equipamentos"}>Aprov. gestor corporativo equipamentos</Option>
                                <Option value={"Aprov. diretoria operações"}>Aprov. diretoria operações</Option>
                                <Option value={"Aprov. diretoria equipamentos"}>Aprov. diretoria equipamentos</Option>
                                <Option value={"Aprov. diretoria geral"}>Aprov. diretoria geral</Option>
                                <Option value={"Aprov. Diretor Final"}>Aprov. Diretor Final</Option>
                                <Option value={"diligenciamento"}>diligenciamento</Option>
                                <Option value={"Faturado"}>Faturado</Option>
                            </Select>
                        </Stack>
                        <Stack>
                            <Typography level="body-sm" fontWeight={"bold"}>N° 1.1.06</Typography>
                            <Stack>
                                <Input value={filtros.numero1106} onChange={e => aplicarFiltros("numero1106", e.target.value)} placeholder="0000000" />
                            </Stack>
                        </Stack>
                        <Stack>
                            <Typography level="body-sm" fontWeight={"bold"}>N° OC</Typography>
                            <Stack>
                                <Input value={filtros.numero1108} onChange={e => aplicarFiltros("numero1108", e.target.value)} placeholder="0000000" />
                            </Stack>
                        </Stack>
                        <Stack>
                            <Typography level="body-sm" fontWeight={"bold"}>N° Solicitação</Typography>
                            <Stack>
                                <input
                                    ref={nSolicitacaoRef}
                                    value={filtros.solicitacao}
                                    // onChange={e => aplicarFiltros("solicitacao", e.target.value)}
                                    onChange={(event) => {
                                        const valor = event.target.value;
                                        aplicarFiltros('solicitacao', valor);
                                        if (valor.length > 0) aplicarFiltros('verTodasCotacoes', true);
                                    }}
                                    placeholder="0000"
                                    style={{ fontSize: "16px", fontWeight: 500, color: "#333", border: '1px solid #ddd', borderRadius: "5px", padding: "10px 10px", backgroundColor: "#fcfcfc" }}
                                />
                            </Stack>
                        </Stack>
                        <Stack>
                            <Typography level="body-sm" fontWeight={"bold"}>Procurar por item (Mínimo 5 caracteres)</Typography>
                            <Stack>
                                <Input value={filtros.item} onChange={e => aplicarFiltros("item", e.target.value)} onBlur={() => filtros.item.length > 0 && filtros.item.length < 5 ? [aplicarFiltros("item", ""), toast.warning("A descrição do item precisa conter pelo menos 5 caracteres.")] : null} placeholder="Ex: Faixa adesiva refletiva" />
                            </Stack>
                        </Stack>
                        <Stack>
                            <Typography level="body-sm" fontWeight={"bold"}>Nome do fornecedor (Mínimo 5 caracteres)</Typography>
                            <Stack>
                                <Input value={filtros.fornecedor} onChange={e => aplicarFiltros("fornecedor", e.target.value)} onBlur={() => filtros.fornecedor.length > 0 && filtros.fornecedor.length < 5 ? [aplicarFiltros("fornecedor", ""), toast.warning("A descrição do fornecedor precisa conter pelo menos 5 caracteres.")] : null} placeholder="Ex: Casa do adubo" />
                            </Stack>
                        </Stack>
                        <Stack>
                            <Typography level="body-sm" fontWeight={"bold"}>Nome do equipamento (Mínimo 5 caracteres)</Typography>
                            <Stack>
                                <Input value={filtros.equipamento} onChange={e => aplicarFiltros("equipamento", e.target.value)} onBlur={() => filtros.equipamento.length > 0 && filtros.equipamento.length < 5 ? [aplicarFiltros("equipamento", ""), toast.warning("A descrição do equipamento precisa conter pelo menos 5 caracteres.")] : null} placeholder="Ex: Caminhão basculante" />
                            </Stack>
                        </Stack>
                        <Stack>
                            <Typography level="body-sm" fontWeight={"bold"}>Prefixo do equipamento</Typography>
                            <Stack>
                                <Input value={filtros.prefixoEquipamento} onChange={e => aplicarFiltros("prefixoEquipamento", e.target.value)} placeholder="Ex: 0.000.0000" />
                            </Stack>
                        </Stack>
                    </Stack>
                    {/* </form> */}
                    <Stack flexDirection={"row"} mt="26px" justifyContent={"space-between"}>
                        <Button onClick={() => setModalFiltros(false)} color="neutral">FECHAR</Button>
                        <Button loading={loading} onClick={() => [buscarCotacoes(), setModalFiltros(false)]}><FaSearch style={{ marginRight: "5px" }} /> ATUALIZAR</Button>
                    </Stack>
                </ModalDialog>
            </Modal>

            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={modalEmailsEnviados}
                onClose={() => setModalEmailsEnviados(false)}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{
                        width: mobile ? "90%" : "70%",
                        borderRadius: 'md',
                        p: 3,
                        boxShadow: 'lg',
                        maxHeight: "85vh",
                        overflowY: "auto",
                        overflowX: "hidden"
                    }}
                >
                    <ModalClose
                        variant="outlined"
                        sx={{
                            top: '10px',
                            right: '10px',
                            boxShadow: '0 2px 12px 0 rgba(0 0 0 / 0.2)',
                            borderRadius: '50%',
                            bgcolor: 'background.surface',
                        }}
                    />
                    <Typography
                        component="h2"
                        id="modal-title"
                        level="h4"
                        textColor="inherit"
                        fontWeight="lg"
                        mb={2}
                    >
                        {emailsEnviados[0]?.assunto || "Emails Enviados"}
                    </Typography>
                    <Stack sx={{ overflowX: mobile ? "auto" : "visible" }}>
                        {emailsEnviados.length > 0 ? (
                            <table style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                fontSize: "0.95rem"
                            }}>
                                <thead>
                                    <tr style={{
                                        backgroundColor: "#f5f5f5",
                                        borderBottom: "2px solid #ddd"
                                    }}>
                                        <th style={{
                                            padding: "12px",
                                            textAlign: "left",
                                            fontWeight: "600",
                                            borderRight: "1px solid #ddd"
                                        }}>Remetente</th>
                                        <th style={{
                                            padding: "12px",
                                            textAlign: "left",
                                            fontWeight: "600",
                                            borderRight: "1px solid #ddd"
                                        }}>Destinatários</th>
                                        <th style={{
                                            padding: "12px",
                                            textAlign: "left",
                                            fontWeight: "600",
                                            borderRight: "1px solid #ddd"
                                        }}>Cópia</th>
                                        <th style={{
                                            padding: "12px",
                                            textAlign: "left",
                                            fontWeight: "600",
                                            borderRight: "1px solid #ddd"
                                        }}>Data de Envio</th>
                                        <th style={{
                                            padding: "12px",
                                            textAlign: "left",
                                            fontWeight: "600"
                                        }}>Mensagem</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {emailsEnviados.map((email, indice) => (
                                        <tr key={indice} style={{
                                            borderBottom: "1px solid #eee",
                                            backgroundColor: indice % 2 === 0 ? "#fff" : "#fafafa"
                                        }}>
                                            <td style={{
                                                padding: "12px",
                                                borderRight: "1px solid #ddd",
                                                maxWidth: "150px",
                                                wordBreak: "break-word"
                                            }}>
                                                {email.usuario?.nome || "N/A"}
                                            </td>
                                            <td style={{
                                                padding: "12px",
                                                borderRight: "1px solid #ddd",
                                                maxWidth: "200px",
                                                wordBreak: "break-word"
                                            }}>
                                                {email.destinatarios?.join(", ") || "N/A"}
                                            </td>
                                            <td style={{
                                                padding: "12px",
                                                borderRight: "1px solid #ddd",
                                                maxWidth: "200px",
                                                wordBreak: "break-word"
                                            }}>
                                                {email.usuarioCopia?.join(", ") || "N/A"}
                                            </td>
                                            <td style={{
                                                padding: "12px",
                                                borderRight: "1px solid #ddd",
                                                maxWidth: "160px",
                                                wordBreak: "break-word"
                                            }}>
                                                {email.created_at ? formatarDataHoraBrasil(email.created_at) : "N/A"}
                                            </td>
                                            <td style={{
                                                padding: "12px",
                                                maxWidth: "250px",
                                                cursor: email.mensagem?.length > 100 ? "pointer" : "default",
                                                textDecoration: email.mensagem?.length > 100 ? "underline" : "none",
                                                color: email.mensagem?.length > 100 ? "#1976d2" : "inherit"
                                            }}
                                                onClick={() => {
                                                    if (email.mensagem?.length > 100) {
                                                        setDadosModalMensagem({ titulo: "Email - Mensagem Completa", mensagem: email.mensagem });
                                                        setModalMensagem(true);
                                                        setEmailSelecionado(email);
                                                    }
                                                }}
                                            >
                                                {email.mensagem?.length > 100 ? email.mensagem?.substring(0, 100) + "..." : email.mensagem}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <Stack flexDirection="row" alignItems="center" justifyContent="center" py={4}>
                                <IoInformationCircleSharp size={20} />
                                <Typography sx={{ marginLeft: "10px" }}>Nenhum email enviado</Typography>
                            </Stack>
                        )}
                    </Stack>
                </Sheet>
            </Modal>

            <Modal
                aria-labelledby="modal-title-mensagem"
                aria-describedby="modal-desc-mensagem"
                open={modalMensagem}
                onClose={() => setModalMensagem(false)}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{
                        width: mobile ? "90%" : "70%",
                        borderRadius: 'md',
                        p: 3,
                        boxShadow: 'lg',
                        maxHeight: "85vh",
                        overflowY: "auto",
                        overflowX: "hidden"
                    }}
                >
                    <ModalClose
                        variant="outlined"
                        sx={{
                            top: '10px',
                            right: '10px',
                            boxShadow: '0 2px 12px 0 rgba(0 0 0 / 0.2)',
                            borderRadius: '50%',
                            bgcolor: 'background.surface',
                        }}
                    />
                    <Typography
                        component="h2"
                        id="modal-title-mensagem"
                        level="h4"
                        textColor="inherit"
                        fontWeight="lg"
                        mb={2}
                    >
                        {dadosModalMensagem.titulo}
                    </Typography>
                    <Typography
                        level="body-md"
                        sx={{
                            whiteSpace: 'pre-wrap',
                            wordWrap: 'break-word',
                            lineHeight: 1.6
                        }}
                    >
                        {dadosModalMensagem.mensagem}
                    </Typography>
                </Sheet>
            </Modal>
        </Stack>
    );
}